import ReactTimeAgo from "react-time-ago";

const TimeAgo = (props) => {
  const date = new Date(props.date).getTime();
  return <div>{date && date !== NaN && <ReactTimeAgo date={date} />}</div>;
};
export default TimeAgo;
